// Copyright (c) 2020 Deere & Company

export const getBasePath = () => {

    const domain = window.location.hostname;

    const basePathMapper = {
        'atp-devl.deere.com': '//atp-service.tal.deere.com/atp',
        'atp.tal.deere.com': '//atp-service.tal.deere.com/atp',
        'atpqual.tal.deere.com': '//atpqual-service.tal.deere.com/atp',
        'atp-qual.deere.com': '//atpqual-service.tal.deere.com/atp',
        'atp-qual.om-comar-apps-devl-vpn.us.e26.c01.johndeerecloud.com': '//atpqual-service.tal.deere.com/atp',
        'atp.deere.com': '//atp-service.deere.com/atp',
        'atp-prod.deere.com': '//atp-service.deere.com/atp',
        localhost: '/atp'
    };


    return basePathMapper[domain] ? basePathMapper[domain] : basePathMapper.localhost;

};
